








import { computed, defineComponent, useContext } from '@nuxtjs/composition-api';
import CategoryCollectionProducts from 'templates/category/parts/CategoryCollectionProducts.vue';

import placeholderTypes from '~/diptyqueTheme/config/placeholderTypes';

export default defineComponent({
  name: 'PlaceholderSection',
  components: {
    CategoryCollectionProducts,
    ProductSlider: () => import('templates/sections/ProductSlider/index.vue')
  },
  props: {
    sectionData: {
      required: false,
      type: Object,
      default: () => ({})
    },
    config: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  setup(props) {
    const {
      app: { i18n }
    } = useContext();
    const placeholderType = computed(() => {
      return (
        props.sectionData?.__typename === 'Placeholder' &&
        props.sectionData?.type
      );
    });

    const componentsMap = {
      [placeholderTypes.MAGENTO_COLLECTION_PRODUCTS]:
        'CategoryCollectionProducts',
      [placeholderTypes.MAGENTO_UPSELL_PRODUCTS]: 'ProductSlider'
    };

    const componentName = computed<string>(() => {
      return componentsMap[placeholderType.value] || null;
    });

    const hasUpsellProducts = computed<boolean>(() => {
      return props.config?.pdpUpsellProducts?.length > 0;
    });

    const magentoCollectionProductsProps = computed(() => ({
      key: 'placeholder-category-collection-products',
      heading: props.sectionData?.heading || '',
      productsSku: props.config?.products || []
    }));

    const magentoUpsellProductsProps = computed(() => ({
      key: 'placeholder-product-slider',
      uniqueKey: 'upsell-products',
      sectionData: {
        heading: i18n.t('Explore the Collection'),
        productGroupsCollection: {
          items: [
            {
              groupTitle: 'upsell-products-group',
              nostoSlot: null,
              sku: props.config.pdpUpsellProducts
                ? props.config.pdpUpsellProducts.map((el) => el.sku)
                : [],
              type: 'list of sku'
            }
          ]
        }
      },
      config: {}
    }));

    const componentProps = computed(() => {
      switch (placeholderType.value) {
        case placeholderTypes.MAGENTO_COLLECTION_PRODUCTS:
          return magentoCollectionProductsProps.value;
        case placeholderTypes.MAGENTO_UPSELL_PRODUCTS:
          if (hasUpsellProducts.value) {
            return magentoUpsellProductsProps.value;
          }
          return {};
        default:
          return {};
      }
    });

    return {
      hasUpsellProducts,
      componentName,
      componentProps
    };
  }
});
